import React from 'react';
import { IoLogoMedium } from 'react-icons/io5';
import './Medium.css';

const Footer = ({ data }) => {
    if (data) {
        var networks = data.social.map(function (network) {
            if (network.name === 'medium') {
                return (
                    <li key={network.name} className="medium-icon">
                        <a href={network.url}>
                            <IoLogoMedium />
                        </a>
                    </li>
                );
            }
            return (
                <li key={network.name}>
                    <a href={network.url}>
                        <i className={network.className}></i>
                    </a>
                </li>
            );
        });
    }

    return (
        <footer>
            <div className="row">
                <div className="twelve columns">
                    <ul className="social-links">{networks}</ul>
                </div>
                <div id="go-top">
                    <a
                        className="smoothscroll"
                        title="Back to Top"
                        href="#home">
                        <i className="icon-up-open"></i>
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
